import React from 'react';
import { useContext } from 'react';
import { I18nContext } from 'translations';
import { Grid, Button } from '@material-ui/core';
import DriverSelected from 'components/Cards/DriverSelected';
import ModalServiceDriver from 'components/Modals/ModalServiceDriver';

const ReservationsOptions = ({ listReservations, bookingReservationId, setOpenModalServiceDriver, selectedPrincipalBooking, openModalServiceDriver }) => {
  const { translate } = useContext(I18nContext);
  
  return (
    <Grid item sm={12} xs={12} style={{ paddingTop: 0 }}>
      {!bookingReservationId &&
        <div className="drivers-reserved">
          <p><b>{translate('app.bookingReserved.driversReserved')}: {listReservations.length}</b></p>
          <Button
            variant="contained"
            size="small"
            onClick={() => setOpenModalServiceDriver(true)}
          >
            {translate('app.express.driverHours')}
          </Button>
        </div>
      }
      {bookingReservationId && (
        <DriverSelected
          driver={bookingReservationId}
          setOpenModalServiceDriver={setOpenModalServiceDriver}
        />
      )}
      {listReservations && listReservations.length > 0 && (
        <ModalServiceDriver
          open={openModalServiceDriver}
          setOpen={setOpenModalServiceDriver}
          selectedPrincipalBooking={selectedPrincipalBooking}
          listReservations={listReservations}
          bookingReservationId={bookingReservationId}
          setOpenModalServiceDriver={setOpenModalServiceDriver}
        />
      )}
    </Grid>
  );
};

export default ReservationsOptions;